import { useCallback, useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { CardType } from 'utils/customTypes';
import { GridItemData } from '../GridItem';
import {
  DRILLDOWN_KEY_TO_ENTITY_TYPE,
  INSIGHT_TO_DRILLDOWN_CATEGORY,
} from 'types/store/normalized/insights/InsightCatalogue';
import { useHistory } from 'react-router-dom';
import { PATHS } from 'utils/constants';
import { DashboardContext } from 'Pages/DashboardsDetailsPage/DashboardContext';
import {
  setInsightDrilldownFilters,
  clearInsightDrilldownFilters,
} from 'state/normalized/insightDrilldownFilters/insightDrilldownFiltersSlice';
import { InsightDrilldownSelectedData } from '../../../../../types/store/normalized/insights/insightFilterMetadata';

export const useDrillDown = () => {
  const { dashboardId } = useContext(DashboardContext);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleDrillDown = useCallback(
    (
      cardType: CardType,
      drilldownKey?: string,
      data?: InsightDrilldownSelectedData
    ) => {
      const entityType = INSIGHT_TO_DRILLDOWN_CATEGORY[cardType.insightId];
      const drilldownEntityType =
        DRILLDOWN_KEY_TO_ENTITY_TYPE[drilldownKey ?? ''];

      const entity = drilldownEntityType ?? entityType;
      if (!entity) return;

      dispatch(setInsightDrilldownFilters(data));
      history.push(
        PATHS.DASHBOARD_DRILLDOWN_PAGE.replace(':dashboardId', dashboardId)
          .replace(':entityType', entity)
          .replace(':insightId', cardType.insightId)
          .replace(':drilldownKey', drilldownKey ?? '')
      );
    },
    [dashboardId, history, dispatch]
  );

  const closeDrillDown = useCallback(() => {
    dispatch(clearInsightDrilldownFilters());
    history.push(`${PATHS.DASHBOARD_PAGE}/${dashboardId}`);
  }, [dashboardId, history, dispatch]);

  const drillDownHandlersByGridId = useMemo(() => {
    const handlers: Record<string, () => void> = {};
    return handlers;
  }, []);

  const updateDrillDownHandlers = useCallback(
    (validatedGridItems: GridItemData[]) => {
      const handlers: Record<string, () => void> = {};
      validatedGridItems.forEach((item) => {
        handlers[item.gridId] = () => {
          handleDrillDown(item.cardType);
        };
      });
      return handlers;
    },
    [handleDrillDown]
  );

  return {
    handleDrillDown,
    closeDrillDown,
    drillDownHandlersByGridId,
    updateDrillDownHandlers,
  };
};
